var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckInViewProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.288 11.3C0.088 11.1 -0.00783333 10.8625 0.0005 10.5875C0.00883333 10.3125 0.104667 10.0833 0.288 9.9L5.563 4.55C5.94633 4.16667 6.42133 3.975 6.988 3.975C7.55467 3.975 8.02967 4.16667 8.413 4.55L10.988 7.15L16.188 2H14.588C14.3047 2 14.0672 1.90417 13.8755 1.7125C13.6838 1.52083 13.588 1.28333 13.588 1C13.588 0.716667 13.6838 0.479167 13.8755 0.2875C14.0672 0.0958333 14.3047 0 14.588 0H18.588C18.8713 0 19.1088 0.0958333 19.3005 0.2875C19.4922 0.479167 19.588 0.716667 19.588 1V5C19.588 5.28333 19.4922 5.52083 19.3005 5.7125C19.1088 5.90417 18.8713 6 18.588 6C18.3047 6 18.0672 5.90417 17.8755 5.7125C17.6838 5.52083 17.588 5.28333 17.588 5V3.4L12.413 8.575C12.0297 8.95833 11.5547 9.15 10.988 9.15C10.4213 9.15 9.94633 8.95833 9.563 8.575L6.988 6L1.688 11.3C1.50467 11.4833 1.27133 11.575 0.988 11.575C0.704667 11.575 0.471333 11.4833 0.288 11.3Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckInViewProgress);
export default __webpack_public_path__ + "static/media/CheckInViewProgress.8727f9814e45e15b81e38ed06f68ac5b.svg";
export { ForwardRef as ReactComponent };